<template>
  <v-app id="app" class="auth-layout">
    <v-main>
      <myHeader />

      <v-container fluid fill-height>
        <router-view />
      </v-container>
    </v-main>

    <!-- <span class="version">{{ $getAppVersion() }}</span> -->
  </v-app>
</template>

<script>
import myHeader from "@/themes/partials/shared/HeaderAuth.vue"

export default {
  name: "my-login-layout",

  components: {
    myHeader,
  },
}
</script>
